'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';
	var arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	var arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';

	// ＜ルート設定対応＞要素が空だったら削除
	var removeElmIfEmpty = function removeElmIfEmpty() {
		$('.js-checkEmptyElm').each(function (idx, val) {
			if (!$(val).text().length) {
				$(val).remove();
			}
		});
	};
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	var removeBlockIfListEmpty = function removeBlockIfListEmpty() {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};

	// モーダル
	var modalImg = function modalImg() {
		$('.mod-modal').on('click', function (e) {
			var HTML = '<div class="mod-modal-overlay">';
			HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#close" /></svg></span>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
			$('body').append(HTML);

			var $overlay = $('.mod-modal-overlay');
			$overlay.addClass('is-active');
			setTimeout(function () {
				$overlay.addClass('is-visible');

				$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
					$overlay.removeClass('is-visible');
					setTimeout(function () {
						$overlay.removeClass('is-active');
						$overlay.remove();
					}, 400);
				});
			});
		});

		$('.mod-modal02').on('click', function (e) {

			var $overlay = $('.mod-modal02-conts');
			$overlay.addClass('is-active');
			setTimeout(function () {
				$overlay.addClass('is-visible');

				$('.mod-modal02-conts, .mod-modal02-closeBtn').on('click', function (e) {
					if (!$(e.target).closest('.mod-modal02-conts-block').length) {
						$overlay.removeClass('is-visible');
						setTimeout(function () {
							$overlay.removeClass('is-active');
						}, 400);
					}
				});
			});
		});
	};

	// TOPICS
	var topicsSlide = function topicsSlide() {
		if ($('.idx-topics-slider').length) {
			$('.idx-topics-slider').slick({
				infinite: true,
				speed: 1500,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 4,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2
					}
				}]
			});
		}
	};

	removeElmIfEmpty();
	removeBlockIfListEmpty();
	modalImg();
	topicsSlide();
})(window.jQuery, window.FUNCTIONS);